export enum ListActionTarget {
    Cart = 'Cart',
    List = 'List'
}
